import React, { Component } from 'react'
import { connect } from 'react-redux'

import { setFilter } from '../actions'

import bindActionCreators from '../../../../lib/utils/bindActionCreators'

import SearchField from '../../../../lib/components/SearchField'

/**
 * @typedef {object} Props
 * @property {typeof setFilter} setFilter
 */

/** @extends {Component<Props>} */
export class MoreFilter extends Component {
  /**
   * @param {React.KeyboardEvent<HTMLInputElement>} e
   */
  handleFilterChange = e => {
    const { value } = e.target
    const { setFilter } = this.props

    if (e.key === 'Enter') {
      setFilter('other', value)
    }
  }

  render = () => {
    return <SearchField placeholder="Search by name..." onKeyPress={ this.handleFilterChange } />
  }
}

const mapDispatchToProps = bindActionCreators({
  setFilter,
})

export default connect(
  null,
  mapDispatchToProps
)(MoreFilter)



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/components/MoreFilter.jsx